import { Spacing } from '@kezios/design-system';
import { Flex, Text } from '@mantine/core';
import { LinkWithQueryParams } from 'components/website/components/atoms/LinkWithQueryParams/LinkWithQueryParams';
import { useTranslations } from 'use-intl';

import css from './Item.module.css';

export type ItemProps = {
  Icon: React.ReactNode;
  textId: string;
};

export const Item = ({ Icon, textId }: ItemProps) => {
  const t = useTranslations('section.hero.description.items');

  return (
    <Flex gap={Spacing.s4} align="center">
      {Icon}
      <Text variant="textXl" c="gray.6">
        {t.rich(textId, {
          u: chunks => (
            <LinkWithQueryParams href={`/${textId}`} className={css.link}>
              <u>{chunks}</u>
            </LinkWithQueryParams>
          ),
        })}
      </Text>
    </Flex>
  );
};
